module.exports = __webpack_public_path__ + "img/done.83b58e61.png";